<i2g-router-link
  buttonStyle="plain"
  [route]="viewDocumentRoute.route"
  [trackingObject]="trackingObject"
  [trackingAction]="viewDocumentRoute.trackingAction"
>
  <div class="recently-edited-document-wrapper">
    <div class="description">
      {{
        'HOME.LABEL_FOR_CLIENT.' + documentType
          | uppercase
          | translate: mainTranslationParams
      }}
    </div>

    <app-document-status
      class="document-status"
      [documentType]="documentType"
      [documentState]="recentlyEditedDocument.states"
      [documentCalculationResult]="recentlyEditedDocument.calculationResult"
      [showRecurringIcon]="
        !!(enableRecurring && (documentSchedule$ | async)?.interval)
      "
      [featureToggles]="featureToggles"
    >
    </app-document-status>
  </div>
</i2g-router-link>
